export const NOTIFICATION_REQUEST = 'NOTIFICATION_REQUEST'